// extracted by mini-css-extract-plugin
module.exports = {"cell":"Item_cell__1O3NA","icon":"Item_icon__BMnZ7"};